"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    large: {
        "box-shadow": "0px 16px 40px rgba(0, 0, 0, 0.1)"
    },
    small: {
        "box-shadow": "0px 4px 8px rgba(0, 0, 0, 0.1)",
    }
};
// Path: src/privateTokens/elevation/vertical.ts
//# sourceMappingURL=vertical.js.map